import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  WcgButtonComponent,
  WcgDialogComponent,
} from '@wcg/frontend-framework';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DELETE_DIALOG_DATA } from '@shared/dialogs/types';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [WcgDialogComponent, WcgButtonComponent],
  selector: 'wcg-eligibility-dialog',
  styleUrls: ['./eligibility.dialog.scss'],
  template: `
    <wcg-dialog [title]="data.title" [description]="data.description">
      <div class="w-full flex mt-8" content>
        <p class="eligibility-dialog-text-content">{{ data.errorText }}</p>
      </div>
      <div primary>
        <wcg-button
          [color]="data.buttons.primaryColor"
          (click)="confirm()"
          data-testid="eligibility-dialog__confirm"
        >
          {{ data.buttons.deleteButtonText }}
        </wcg-button>
      </div>
    </wcg-dialog>
  `,
})
export class EligibilityDialogComponent {
  public readonly data = inject<DELETE_DIALOG_DATA>(MAT_DIALOG_DATA);
  private readonly _dialogRef = inject(
    MatDialogRef<EligibilityDialogComponent>,
  );

  cancel(): void {
    this._dialogRef.close();
  }
  confirm(): void {
    this._dialogRef.close();
  }
}
